Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
    };

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }

    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }

    return fmt;
};
Number.prototype.format = function (n) {
    let s = this;
    if (typeof s == "string") {
        var val = parseFloat(s.replace(/[^\d.-]/g, ""));
        if (isNaN(val)) {
            s = 0;
        } else {
            s = val;
        }
    }
    var idx = (s + "").indexOf(".");
    n = typeof n == "undefined" ? (idx > -1 ? (s + "").length - idx - 1 : 0) : n;
    n = n >= 0 && n <= 20 ? n : 0;
    s = parseFloat((s + "").replace(/[^\d.-]/g, ""));
    if (isNaN(s)) {
        s = 0;
    }
    var isMinus = s < 0;
    var multi = Math.pow(10, n);
    s = Math.round(s * multi) / multi;
    s = Math.abs(s).toFixed(n) + "";
    var l = s.split(".")[0].split("").reverse(),
        r = s.split(".")[1];
    let t = "";
    for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
    }
    return (isMinus ? "-" : "") + t.split("").reverse().join("") + (r ? "." + r : "");
};
